var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"main-footer"},[_c('div',{staticClass:"float-right d-none d-sm-inline"},[_vm._v(" Rumahweb Messenger v"+_vm._s(_vm.version)+" ")]),_c('strong',[_vm._v("Copyright © 2021")])])
}
var staticRenderFns = []

export { render, staticRenderFns }